import React, { useContext, useEffect, useState, useRef } from 'react';
import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity';
import FilterWrapper from './FilterWrapper';
import { PeFilterContext } from '../../Contexts/PeFilterContext';


function TargetGroup({ open, accordionClick, targetGroupOptions, filterGroupUrl, setTargetGroupOptions, label, customPathname }) {

  const { targetGroup, setTargetGroup, refineSearchFilters } = useContext(PeFilterContext);
  const [companyVal, setCompanyVal] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (companyVal.trim() !== "") {
        // Filter targetGroup based on search
        const filtered = targetGroupOptions.filter(option => 
          option.name.toLowerCase().includes(companyVal.toLowerCase())
        );
        setFetchedData(filtered);
        setShowDropdown(true);
      } else if (isFocused) {
        // Show selected items when focused but no search text
        const selectedItems = targetGroupOptions.filter(option => option.isChecked);
        if (selectedItems.length > 0) {
          setFetchedData(selectedItems);
          setShowDropdown(true);
        } else {
          setShowDropdown(false);
          setFetchedData([]);
        }
      } else {
        setShowDropdown(false);
        setFetchedData([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [companyVal, targetGroupOptions, isFocused]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleGroupChange = (e) => {
    const { checked, name } = e.target;
    console.log(checked, name, "listner")
    // Update the local targetGroupOptions state
    const updatedOptions = targetGroupOptions.map(option =>
      option.name === name ? { ...option, isChecked: checked } : option
    );
    setTargetGroupOptions(updatedOptions);
    
    // Update the context targetGroup state
    setTargetGroup(prev => (prev || []).map(option =>
      option.name === name ? { ...option, isChecked: checked } : option
    ));
  };

  const selectedCount = targetGroup?.filter((option) => option.isChecked).length || 0;
  const hasValue = companyVal || selectedCount > 0;

  return (
    <div className="relative">
      {/* Dropdown - Positioned BELOW the input */}
      {showDropdown && fetchedData.length > 0 && (
        <div ref={dropdownRef} className="absolute z-50 w-full top-full mt-1 bg-white border border-gray-100 rounded-lg shadow-sm max-h-64 overflow-y-auto">
          <MultiSelectEntity
            handleEntityChange={handleGroupChange}
            primaryEntity={fetchedData}
            setCompanyVal={setCompanyVal}
            customPathname={customPathname}
            showAll={false}
            city="city"
          />
        </div>
      )}

      <div className={`absolute left-3 transition-all duration-200 pointer-events-none flex items-center gap-2 z-10 ${isFocused || hasValue
          ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]'
          : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
        }`}>
        <span>{label}</span>
        {(isFocused || hasValue) && selectedCount > 0 && (
          <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
            {selectedCount}
          </span>
        )}
      </div>

      <input
        ref={inputRef}
        type="text"
        value={companyVal}
        onChange={(e) => setCompanyVal(e.target.value)}
        onFocus={() => {
          setIsFocused(true);
          if (companyVal.trim() !== "") {
            setShowDropdown(true);
          } else {
            // Show selected items when focused but no search text
            const selectedItems = targetGroupOptions.filter(option => option.isChecked);
            if (selectedItems.length > 0) {
              setFetchedData(selectedItems);
              setShowDropdown(true);
            }
          }
        }}
        onBlur={() => {
          setTimeout(() => setIsFocused(false), 200);
        }}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
        placeholder=""
      />
    </div>
  );
}

export default TargetGroup;
